<template>
  <router-view v-if="ready" />
</template>

<script>
export default {
  data() {
    return {
      ready: false,
    };
  },
  created: function () {
    window.addEventListener("keyup", this.historyBack);

    // If there is no dark mode prference in local storage, set it to system preference
    if (localStorage.getItem("darkMode") === null) {
      localStorage.setItem("darkMode", "true");
      
    }
 
    if (localStorage.getItem("darkMode") === "true") {
      this.$store.state.auth.status.dark = true;
      
    } else {
      this.$store.state.auth.status.dark = false;

    }
    
    

    this.$store
      .dispatch("auth/checkToken")
      .then(() => {
        this.ready = true;
      })
      .catch((err) => {
        console.error("Token check failed:", err);
        this.$store.dispatch("auth/logout");
        window.location.href =
          "https://gateway.varsanpr.com/login?redirect=" +
          window.location.origin +
          "/login";
      });
  },
  methods: {
    // historyBack(event) {
    //   if(event.keyCode === 32) {
    //     this.$router.go(-1);
    //   }
    // }
  },
};
</script>
